import React, { createContext, useContext, useState, useEffect } from 'react';
import { themes, applyTheme, getCurrentTheme, initializeTheme } from '../styles/themes';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(getCurrentTheme());

  useEffect(() => {
    initializeTheme();
  }, []);

  const changeTheme = (themeName) => {
    if (themes[themeName]) {
      applyTheme(themeName);
      setCurrentTheme(themeName);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};
